import Modal from 'developer_components/newModal';
import {MAX_ICON_WHITE_24} from 'components/tourist-leads/icons';
import {reachGoal} from 'components/tourist-leads/widget-actions';

const MENU_ITEMS = [
    {
        action: 'podbor',
        title: 'Подобрать жильё',
        subtitle: 'Бесплатно подберем лучшие варианты',
        iconClass: 'Tourist-leads-menu__icon--podbor',
        iconHTML: `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 10.5V19C4 19.5523 4.44772 20 5 20H9V14H15V20H19C19.5523 20 20 19.5523 20 19V10.5L12 4.5L4 10.5Z" fill="white"/>
            </svg>
        `,
    },
    {
        action: 'max',
        title: 'Написать в MAX',
        subtitle: 'Быстрые ответы от менеджера',
        iconClass: 'Tourist-leads-menu__icon--max',
        iconHTML: MAX_ICON_WHITE_24,
    },
    {
        action: 'call',
        title: 'Позвонить',
        subtitle: 'Бесплатный звонок по России',
        iconClass: 'Tourist-leads-menu__icon--call',
        iconHTML: `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="white"/>
            </svg>
        `,
    },
];

function renderMenuItem(item) {
    return `
        <button type="button" class="Tourist-leads-menu__item js-tourist-leads-menu-item" data-action="${item.action}">
            <span class="Tourist-leads-menu__icon ${item.iconClass}">${item.iconHTML}</span>
            <span class="Tourist-leads-menu__text">
                <span class="Tourist-leads-menu__title">${item.title}</span>
                <span class="Tourist-leads-menu__subtitle">${item.subtitle}</span>
            </span>
            <span class="Tourist-leads-menu__arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.29 6.71C8.9 7.1 8.9 7.73 9.29 8.12L13.17 12L9.29 15.88C8.9 16.27 8.9 16.9 9.29 17.29C9.68 17.68 10.31 17.68 10.7 17.29L15.29 12.7C15.68 12.31 15.68 11.68 15.29 11.29L10.7 6.7C10.31 6.32 9.68 6.32 9.29 6.71Z" fill="currentColor"/>
                </svg>
            </span>
        </button>
    `;
}

function WidgetMenu(options = {}) {
    const $modal = Modal.createFromHTML(`
        <div class="Tourist-leads-menu js-tourist-leads-menu">
            <div class="Tourist-leads-menu__handle" aria-hidden="true"></div>
            <div class="Tourist-leads__close Modal-native__close js-modalClose"></div>
            <div class="Tourist-leads-menu__heading">Мы всегда на связи!</div>
            <div class="Tourist-leads-menu__items">
                ${MENU_ITEMS.map(renderMenuItem).join('')}
            </div>
        </div>
    `, { id: 'Tourist-leads-widget-menu-modal', className: 'Tourist-leads-widget-menu-modal' });

    Modal.call(this, $modal);

    this.onAction = options.onAction || (() => {});

    this.$element.querySelectorAll('.js-tourist-leads-menu-item').forEach(($item) => {
        $item.addEventListener('click', () => {
            const action = $item.dataset.action;
            this.close().then(() => this.onAction(action));
        });
    });

    this.on('open', () => {
        reachGoal('widget_open');
        reachGoal('contact_widget_open');
    });
}

WidgetMenu.prototype = Object.create(Modal.prototype);
Object.defineProperty(WidgetMenu.prototype, 'constructor', {
    value: WidgetMenu,
    enumerable: false,
    writable: true,
});

export default WidgetMenu;
